// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"57eb2008","578":"ddf9cafe","617":"27cff5c9","842":"2f74b30d","970":"38436301","981":"46f5086b"}[chunkId] + ".chunk.js";
};